import _ from "lodash";
import axios from "axios";
import { metricsAPISecretKey, metricsServerUrl } from "config";

const baseURL = metricsServerUrl;
const ENDPOINT = "/api/v1/metrics";
const REQUEST_TIMEOUT = 5000; // 5s max

export const sendDSUsageMetrics = async data => {
  try {
    if (_.isEmpty(data)) return;

    const url = `${baseURL}${ENDPOINT}`;

    // stringify data for transmission
    const payload = JSON.stringify(data);

    await axios.post(url, payload, {
      headers: {
        "x-tod-metrics-api-key": metricsAPISecretKey,
        "Content-Type": "application/json",
      },
      timeout: REQUEST_TIMEOUT,
    });
  } catch (err) {}
};
